/* ==========================================================================
   HUMO BARRILES USA · IDIOMA DE TODA LA PÁGINA
   assets/humo-idioma.js

   La página arranca en español. El selector ES / EN queda fijo arriba a la
   derecha y la elección se recuerda en el navegador.

   Textos: cualquier elemento con data-es y data-en se traduce solo.
   Imágenes con texto: van dos versiones, una con clase solo-es y otra con
   clase solo-en; se muestra la del idioma activo.
   Las secciones con textos dinámicos escuchan el evento humo:idioma.
   ========================================================================== */
(function () {
  'use strict';

  if (window.HUMO_IDIOMA) return;

  var CLAVE = 'humo-lang';
  var lang = 'es';
  try { if (localStorage.getItem(CLAVE) === 'en') lang = 'en'; } catch (e) {}

  /* estilos del selector y de las piezas por idioma */
  var css = document.createElement('style');
  css.textContent =
    'html[data-humo-lang="es"] .solo-en, html[data-humo-lang="en"] .solo-es { display: none !important; }' +
    '.humo-lang { position: fixed; top: 84px; right: 16px; z-index: 60; display: flex; padding: 3px;' +
    ' border: 1px solid rgba(255,229,0,.55); border-radius: 999px; background: rgba(11,12,16,.82);' +
    ' -webkit-backdrop-filter: blur(6px); backdrop-filter: blur(6px); }' +
    '.humo-lang button { min-width: 40px; height: 30px; padding: 0 .7rem; border: 0; border-radius: 999px;' +
    ' background: transparent; color: #fff; font: 800 .78rem/1 Archivo, Arial, sans-serif; letter-spacing: .1em; cursor: pointer; }' +
    '.humo-lang button[aria-pressed="true"] { background: #FFE500; color: #0B0C10; }' +
    '@media (max-width: 767px) { .humo-lang { top: 74px; right: 10px; } .humo-lang button { min-width: 36px; height: 28px; } }';
  document.head.appendChild(css);

  function aplicar(raiz) {
    var nodos = (raiz || document).querySelectorAll('[data-es][data-en]');
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];
      var v = el.getAttribute('data-' + lang);
      var attr = el.getAttribute('data-i18n-attr');
      if (attr) el.setAttribute(attr, v);
      else el.innerHTML = v;
    }
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('data-humo-lang', lang);
    var bs = document.querySelectorAll('.humo-lang button');
    for (var k = 0; k < bs.length; k++) bs[k].setAttribute('aria-pressed', String(bs[k].getAttribute('data-set-lang') === lang));
  }

  function fijar(nuevo) {
    nuevo = nuevo === 'en' ? 'en' : 'es';
    var cambio = nuevo !== lang;
    lang = nuevo;
    try { localStorage.setItem(CLAVE, lang); } catch (e) {}
    aplicar();
    if (cambio) document.dispatchEvent(new CustomEvent('humo:idioma', { detail: { lang: lang } }));
  }

  window.HUMO_IDIOMA = { get: function () { return lang; }, set: fijar, aplicar: aplicar };

  /* aplica el idioma antes de pintar, para que no se vea el cambio */
  document.documentElement.setAttribute('data-humo-lang', lang);

  function arrancar() {
    if (!document.querySelector('.humo-lang')) {
      var sel = document.createElement('div');
      sel.className = 'humo-lang';
      sel.setAttribute('role', 'group');
      sel.setAttribute('aria-label', 'Idioma / Language');
      sel.innerHTML = '<button type="button" data-set-lang="es">ES</button><button type="button" data-set-lang="en">EN</button>';
      document.body.appendChild(sel);
    }
    aplicar();
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('[data-set-lang]');
    if (b) fijar(b.getAttribute('data-set-lang'));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
